import { constants } from '@eti/utils';

const { brands } = constants;
const brandsWithFadeInCard: string[] = [brands.FLIGHTNETWORK, brands.GOTOGATE, brands.MYTRIP];

export const getTransition = ({
  brand,
  isWiderViewport,
  milliSeconds,
}: {
  brand: { code?: string };
  isWiderViewport: boolean;
  milliSeconds?: number;
}) => {
  const fadeInDelayInSeconds =
    isWiderViewport && brand.code && brandsWithFadeInCard.includes(brand.code)
      ? (Number(milliSeconds) || 0) / 1000
      : 0;

  return {
    delay: fadeInDelayInSeconds,
    duration: fadeInDelayInSeconds && 0.8,
  };
};
